import { createFileRoute, redirect } from '@tanstack/react-router';
import { FINCEN_MATCH_BASE_PATH } from '../../../../../../../../features/watchlist/fincen/match/fincen-match-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/fincen/')({
  beforeLoad: () => {
    throw redirect({ to: FINCEN_MATCH_BASE_PATH });
  },
  preload: false,
});
